import { FC } from "react";
import { SCUILoadingLinear } from "../../atomic/atoms";
import { SCUIContent } from "../../atomic/organisms";
import { useTranslation } from "react-i18next";
import CreateTemplate from "../../../src/assets/icons/svg/pageIcons/createTemplate.svg";
import Sections from "../../../src/assets/icons/svg/pageIcons/sections.svg";
import TemplateGallery from "../../../src/assets/icons/svg/pageIcons/templateGallery.svg";
import { SCUIBreadCrumb } from "../../atomic/molecules";
import { Grid, Box } from "@mui/material";
import { Link } from "react-router-dom";

import { PageUrl } from "../../types/enums";
import { ETBHUB, etbCls } from "./emailTemplateBuilder.classes";
export const EmailTemplateBuilder: FC<any> = () => {
  const { t } = useTranslation();
  const loading = false;
  return (
    <>
      <SCUIContent>
        <Box className={ETBHUB.page}>
        <Grid
          className={ETBHUB.layoutShell}
          size={{
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }}>
          <Grid
            className={ETBHUB.headerRow}
            container
            direction="row"
            spacing={2}
            sx={{ marginLeft: "0.5rem" }}
          >
            <SCUIBreadCrumb
              title={"Template Builder"}
              componentLink={"/emailTemplateBuilder"}
              style={{ cursor: "pointer" }}
              onClick={() => {}}
            />
            <SCUILoadingLinear display={loading} />
          </Grid>
          <Grid
            className={ETBHUB.bodyShell}
            size={{
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }}>
            <Grid
              className={ETBHUB.tilesInnerShell}
              size={{
                sm: 12,
                md: 12,
                lg: 12,
                xl: 12
              }}>
              <div>
                <Grid
                  className={ETBHUB.tilesRow}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    gap: "3rem",
                    marginTop: "3rem",
                  }}
                >
                  <Link
                    to="/emailTemplateBuilder/createTemplate"
                    className={etbCls("createTemplate", ETBHUB.linkCreateTemplate)}
                  >
                    <Grid className={ETBHUB.tileCreateTemplate} style={{ cursor: "pointer" }}>
                      <img
                        src={CreateTemplate}
                        className={etbCls("centeredImg", ETBHUB.tileImage)}
                        alt=""
                      />
                      <p
                        className={ETBHUB.tileCaption}
                        style={{
                          textAlign: "center",
                          marginTop: "3rem",
                          maxWidth: "450px",
                        }}
                      >
                        <b className={ETBHUB.tileCaptionTitle}>
                          {t("emailTemplateBuilder.createTemplate")}
                        </b>
                      </p>
                    </Grid>
                  </Link>
                  <Link
                    to="/emailTemplateBuilder/addSection"
                    className={etbCls("addSection", ETBHUB.linkAddSection)}
                  >
                    <Grid className={ETBHUB.tileAddSection} style={{ cursor: "pointer" }}>
                      <img
                        src={CreateTemplate}
                        className={etbCls("centeredImg", ETBHUB.tileImage)}
                        alt=""
                      />
                      <p
                        className={ETBHUB.tileCaption}
                        style={{
                          textAlign: "center",
                          marginTop: "3rem",
                          maxWidth: "450px",
                        }}
                      >
                        <b className={ETBHUB.tileCaptionTitle}>{t("emailTemplateBuilder.createSection")}</b>
                      </p>
                    </Grid>
                  </Link>
                  <Link to={PageUrl.sectionGallery.url} className={etbCls("sections", ETBHUB.linkSectionsGallery)}>
                    <Grid className={ETBHUB.tileSectionsGallery} style={{ cursor: "pointer" }}>
                      <img src={Sections} className={etbCls("centeredImg", ETBHUB.tileImage)} alt="" />
                      <p
                        className={ETBHUB.tileCaption}
                        style={{
                          textAlign: "center",
                          marginTop: "3rem",
                          maxWidth: "450px",
                        }}
                      >
                        <b className={ETBHUB.tileCaptionTitle}>{t("emailTemplateBuilder.sections")}</b>
                      </p>
                    </Grid>
                  </Link>
                  <Link
                    to={PageUrl.templateGallery.url}
                    className={etbCls("templateGallery", ETBHUB.linkTemplateGallery)}
                  >
                    <Grid className={ETBHUB.tileTemplateGallery} style={{ cursor: "pointer" }}>
                      <img
                        src={TemplateGallery}
                        className={etbCls("centeredImg", ETBHUB.tileImage)}
                        alt=""
                      />
                      <p
                        className={ETBHUB.tileCaption}
                        style={{
                          textAlign: "center",
                          marginTop: "3rem",
                          maxWidth: "450px",
                        }}
                      >
                        <b className={ETBHUB.tileCaptionTitle}>{t("emailTemplateBuilder.templateGallery")}</b>
                      </p>
                    </Grid>
                  </Link>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Grid>
        </Box>
      </SCUIContent>
    </>
  );
};
